import { render, staticRenderFns } from "./TServHouseComp.vue?vue&type=template&id=3cfac347&"
import script from "./TServHouseComp.vue?vue&type=script&lang=js&"
export * from "./TServHouseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports